import React, { Component } from "react";
import PropsTypes from "prop-types";
import axios from "axios";
import { getSign } from "virsical-sign";
import SvgTextEllipsis from "./SvgTextEllipsis";
import {
  EndPosition,
  MarkIcon,
  SelectedIcon,
  StartPosition,
  ToolTip,
} from "./SvgModel";
import {
  INITIAL_VALUE,
  POSITION_NONE,
  ReactSVGPanZoom,
  TOOL_AUTO,
  TOOL_NONE,
} from "react-svg-pan-zoom"; // 组件api见：https://github.com/chrvadala/react-svg-pan-zoom
// 组件api见：https://github.com/chrvadala/react-svg-pan-zoom
import _ from "lodash";

const ZOOM_FACTOR = 1.01;
const DEFAULT_WIDTH = 1920; // 缺省宽度
const DEFAULT_HEIGHT = 1080; // 缺省高度
const DEFAULT_BACKGROUND = "#ddd"; // 缺省背景色
const DEFAULT_SVGBACKGROUND = "#fff"; // 缺省svg背景色
const COLOR_DEFAULT = "#999"; // 缺省颜色
const COLOR_SELECTED = "#2a688d"; // 选中颜色
const PATH_STYLE = {
  animation: "dash 5s linear infinite",
  stroke: "#00ba00",
  strokeWidth: "6px",
  fill: "transparent",
  opacity: 1,
};
let dpr = 1;
// 判断终端是否支持 touch 事件, true 支持， false 不支持
const HAVE_TOUCH_EVENT = document.body.ontouchstart !== undefined;

// noRender 加入这个参数，表示只在可见区域内显示工位，其他区域不显示
// 处理移动端的缩放
// 移动端采用antd的高清方案：https://github.com/ant-design/ant-design-mobile/wiki/antd-mobile-0.8-%E4%BB%A5%E4%B8%8A%E7%89%88%E6%9C%AC%E3%80%8C%E9%AB%98%E6%B8%85%E3%80%8D%E6%96%B9%E6%A1%88%E8%AE%BE%E7%BD%AE
// 高清方案会根据系统进行viewport的设置，但会影响SVG的大小，这里获得dpr在componentDidMount是信息放大。
if (window.flex) {
  const ua = navigator.userAgent;
  const matches = ua.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i);
  const UCVersion = ua.match(/U3\/((\d+|\.){5,})/i);
  const isUCHd =
    UCVersion && parseInt(UCVersion[1].split(".").join(""), 10) >= 80;
  const isIos = navigator.appVersion.match(/(iphone|ipad|ipod)/gi);
  if (!isIos && !(matches && matches[1] > 534) && !isUCHd) {
    dpr = 1;
  } else {
    dpr = window.devicePixelRatio;
  }
}

/* 
地图组件的大致逻辑
1， 基于


*/

const path = {
  "/virsical-map": "virsical-map",
  "/vsk/virsical-map": "vsk/virsical-map",
};

const urlSign = (newUrl, token, SING_KEY) => {
  // 开始签名
  //  取第二个 '/' 前的字符
  let restfulPath = newUrl.substring(0, newUrl.indexOf("/", 1));
  if (newUrl && newUrl.includes("/vsk/")) {
    restfulPath = newUrl.substring(
      0,
      newUrl.indexOf("/", newUrl.indexOf("/", 1) + 1)
    );
  }
  let signPath = newUrl;
  // 判断url中如果包含restful前缀，需要清除，签名用
  if (Object.prototype.hasOwnProperty.call(path, restfulPath)) {
    signPath = newUrl.replace(restfulPath, "");
  }
  // 生成签名用的时间戳
  const timestamp = new Date().getTime();

  // 获取token
  const relToken = token.substring(7) || "";
  // 地图服务只签名get请求
  return {
    "vsk-signature": getSign(signPath, relToken, SING_KEY, timestamp),
    test: "test",
    "vsk-timestamp": timestamp,
  };
};

const customGet = (
  url,
  signatureKey,
  restfulSignature,
  token,
  requestPrefix
) => {
  let headers = { Authorization: token, "vsk-auth": token };
  if (signatureKey && restfulSignature) {
    headers = { ...headers, ...urlSign(url, token, signatureKey) };
  }
  return axios.get(requestPrefix + url, { headers: { ...headers } });
};

class WaferMap extends Component {
  center = {};

  constructor(props) {
    super(props);
    this.state = {
      tool: TOOL_AUTO,
      svgValue: INITIAL_VALUE,
      zoom: 1,
      showTip: false,
      tipObj: {},
      selectedEle: [],
      start: null,
      end: null,
      path: "",
      baseMap: {
        baseMapElement: null,
        baseMapUrl: "",
        width: 0,
        height: 0,
        areaAge: "",
      },
      mapElements: [],
      allElements: [],
      selectedCenter: { x: null, y: null }, // 选择区域的中心点
      selectedArea: { x: 0, y: 0, dragWidth: 0, dragHeight: 0 }, // 控制选择区域的位置和大小
      locationSvgMark: {},
      mapColorSet: {},
    };
  }

  componentWillMount() {
    this.center = {
      stationCenterX: Number(this.props.componentWidth || 1920) / 2,
      stationCenterY: Number(this.props.componentHeight || 1080) / 2,
    };
  }

  componentDidMount() {
    const { mapId } = this.props;
    this.loadMapData(mapId);
    this.fitToViewer();
    this.getSVGViewer();
  }

  componentWillReceiveProps(np) {
    const { mapElements, showTip, path } = this.state;
    const {
      mapId,
      multiple,
      reloadMap,
      setSelectedEleFinish,
      selectableType,
      selectedEle,
      selectedIds,
      zoomRate,
      scaleFactorMax,
      scaleFactorMin,
    } = this.props;
    const { showPath, markId, mapZoom, mapMove } = np;
    // 切换地图id时重新加载地图
    if (np.mapId && mapId !== np.mapId) {
      this.loadMapData(np.mapId);
      this.setState({ selectedEle: [], showTip: false });
      return;
    }
    // 当调用重新加载地图时，reloadMap传true
    if (np.reloadMap && reloadMap !== np.reloadMap) {
      this.reloadElements();
      this.setState({ selectedEle: [], showTip: false });
      return;
    }
    if (np.deleteId !== "") {
      this.deleteSelect(np.deleteId);
      return;
    }

    if (
      selectedEle !== np.selectedEle &&
      Array.isArray(np.selectedEle)
    ) {
      if(np.selectedEle.length > 0){
        this.setState({ selectedEle: np.selectedEle });
      } else  {
        this.setState({ selectedEle: [] });
      }
      if (typeof setSelectedEleFinish === "function") {
        setSelectedEleFinish();
      }
      return;
    }

    if (
      selectedIds !== np.selectedIds &&
      Array.isArray(np.selectedIds) &&
      np.selectedIds.length > 0
    ) {
      const eles = [];
      mapElements.forEach((d) => {
        if (np.selectedIds.includes(d.mapElementId)) {
          eles.push({ ...d });
        }
      });
      this.setState({ selectedEle: eles });
    }

    // showPath为false， 清空引导线
    if (this.props.showPath !== showPath && !showPath) {
      // console.log('!showPath')
      this.setState(
        {
          path: "",
          start: null,
          end: null,
        }
        //() => this.fitToViewer()
      );
    }

    // 切换单选多选模式时，清空已选中项
    if (multiple !== np.multiple) {
      this.clearSelectElement();
    }

    // 切换素材类型时，清空已选中项
    if (selectableType !== np.selectableType) {
      this.clearSelectElement();
    }

    if (zoomRate !== np.zoomRate && this.Viewer) {
      let rateZoom = np.zoomRate;
      if (scaleFactorMax && rateZoom > scaleFactorMax) {
        rateZoom = scaleFactorMax;
      }
      if (scaleFactorMin && rateZoom < scaleFactorMin) {
        rateZoom = scaleFactorMin;
      }

      this.fitToViewer(rateZoom);
    }
    // if(selectMode !== np.selectMode){
    //   this.clearSelectElement();
    // }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // 设置元素剧中
    if (
      prevProps.centerElement &&
      prevProps.centerElement.mapElementId !==
        this.props.centerElement.mapElementId &&
      this.props.centerElement.hasOwnProperty("stationx") &&
      this.props.centerElement.hasOwnProperty("stationy") &&
      this.props.centerElement.hasOwnProperty("customElementWidth") &&
      this.props.centerElement.hasOwnProperty("customElementHeight")
    ) {
      this.setEleToCenter(this.props.centerElement);
    }
  }

  // 初始化加载地图所用的数据
  loadMapData = (mapId) => {
    const {
      token,
      signatureKey,
      restfulSignature,
      reloadFinish,
      onElementsLoad,
      requestPrefix,
      defaultPath,
    } = this.props;
    // 加载地图基础信息
    customGet(
      `/${defaultPath}virsical-map/map/${mapId}`,
      signatureKey,
      restfulSignature,
      token,
      requestPrefix
    )
      // axios.get(`/virsical-map/map/${mapId}`, { headers: { Authorization: token } })
      .then(({ data }) => {
        reloadFinish();
        if (data && data.code === 0) {
          let objIcon = {};
          let objColor = {};
          if (data.data.icon) {
            objIcon = JSON.parse(data.data.icon);
          }
          if (data.data.colors) {
            objColor = JSON.parse(data.data.colors);
          }

          this.setState({
            baseMap: data.data || {},
            locationSvgMark: objIcon,
            mapColorSet: objColor,
          });
          this.fitToViewer();
        }
      })
      .catch(() => {
        console.error("地图获取失败");
      });
    // 加载地图上所有元素信息和元素位置信息
    customGet(
      `/${defaultPath}virsical-map/map-element/list?mapId=${mapId}`,
      signatureKey,
      restfulSignature,
      token,
      requestPrefix
    )
      // axios.get(`/virsical-map/map-element/list?mapId=${mapId}`, { headers: { Authorization: token } })
      .then(({ data }) => {
        if (data && data.code === 0) {
          const mapElements = [];
          data.data.forEach((data) => {
            // if (data.svgId === 0) {
            const obj = data;
            obj.viewBox = data.viewBox;
            obj.svgWidth = Number(obj.customElementWidth);
            obj.svgHeight = Number(obj.customElementHeight);
            obj.centerx = Number(obj.stationx) + Number(obj.svgWidth);
            obj.centery = Number(obj.stationy) + Number(obj.svgHeight);
            obj.axisx = 50;
            obj.axixy = 50;
            obj.fontSize = 12;
            obj.stationx = Number(obj.stationx);
            obj.stationy = Number(obj.stationy);
            obj.cycleValue = Number(obj.cycleValue);
            obj.direction = Number(obj.direction);
            mapElements.push(obj);
            // }
          });
          this.setState({ mapElements: mapElements || [] });
          onElementsLoad(mapElements);
          this.fitToViewer();
        }
      })
      .catch(() => {
        console.error("地图元素获取失败");
      });
    // 加载所有元素资源列表，包含元素状态
    customGet(
      `/${defaultPath}virsical-map/svg/enable-list-and-svg-state`,
      signatureKey,
      restfulSignature,
      token,
      requestPrefix
    )
      // axios.get(`/virsical-map/svg/enable-list-and-svg-state`, { headers: { Authorization: token } })
      .then(({ data }) => {
        if (data && data.code === 0) {
          this.setState({ allElements: data.data || [] });
          this.fitToViewer();
        }
      })
      .catch(() => {
        console.error("素材列表获取失败");
      });
  };

  // 更新地图上的元素
  reloadElements = () => {
    const {
      mapId,
      token,
      reloadFinish,
      signatureKey,
      restfulSignature,
      requestPrefix,
      defaultPath,
    } = this.props;
    // 加载地图上所有元素信息和元素位置信息
    customGet(
      `/${defaultPath}virsical-map/map-element/list?mapId=${mapId}`,
      signatureKey,
      restfulSignature,
      token,
      requestPrefix
    )
      // axios.get(`/virsical-map/map-element/list?mapId=${mapId}`, { headers: { Authorization: token } })
      .then(({ data }) => {
        reloadFinish();
        if (data && data.code === 0) {
          const mapElements = [];
          data.data.forEach((data) => {
            //  if (data.svgId === 0) {
            const obj = data;
            obj.viewBox = data.viewBox;
            obj.svgWidth = Number(obj.customElementWidth);
            obj.svgHeight = Number(obj.customElementHeight);
            obj.centerx = Number(obj.stationx) + Number(obj.svgWidth);
            obj.centery = Number(obj.stationy) + Number(obj.svgHeight);
            obj.axisx = 50;
            obj.axixy = 50;
            obj.fontSize = 12;
            obj.stationx = Number(obj.stationx);
            obj.stationy = Number(obj.stationy);
            obj.cycleValue = Number(obj.cycleValue);
            obj.direction = Number(obj.direction);
            mapElements.push(obj);
            // }
          });
          this.setState({ mapElements: mapElements || [] });
        }
      })
      .catch(() => {
        reloadFinish("error");
        console.error("地图元素获取失败");
      });
    // 加载所有元素资源列表，包含元素状态
    customGet(
      `/${defaultPath}virsical-map/svg/enable-list-and-svg-state`,
      signatureKey,
      restfulSignature,
      token,
      requestPrefix
    )
      // axios.get(`/virsical-map/svg/enable-list-and-svg-state`, { headers: { Authorization: token } })
      .then(({ data }) => {
        if (data && data.code === 0) {
          this.setState({ allElements: data.data || [] });
        }
      })
      .catch(() => {
        console.error("素材列表获取失败");
      });
  };

  // 适配view
  fitToViewer = (rateZoom = null) => {
    // console.log('适配view')
    this.Viewer.fitToViewer();
    const { componentWidth, componentHeight, legendList, zoomRate } =
      this.props;
    let { fitWidthOrHeight } = this.props;
    let {
      baseMap: { height, width },
    } = this.state;
    let zoom = 1;
    let mapWidth = Number(width);
    let mapHeight = Number(height);
    let curRate = rateZoom || zoomRate;
    /*
    适配规则

    zoomHeight: 画布与地图底图高度比例；
    zoomWidth： 画布于地图底图宽度比例；
    zoomHeight < zoomWidth 则按高度适配，以高度比例缩放；
    zoomHeight > zoomWidth 则按宽度适配，以宽度比例缩放；
    */
    if (height && width) {
      const mapHeight = Number(height);
      const mapWidth = Number(width);
      const zoomHeight = Number(componentHeight) / Number(mapHeight);
      const zoomWidth = Number(componentWidth) / Number(mapWidth);
      if (zoomHeight < zoomWidth) {
        zoom = zoomHeight;
      } else {
        zoom = zoomWidth;
      }
    }

    if (legendList.length > 0) {
      mapHeight += 100;
    }
    // console.log('fitToViewer width height', width, height)
    this.Viewer.setPointOnViewerCenter(
      (Number(mapWidth) || DEFAULT_WIDTH) / 2,
      (Number(mapHeight) || DEFAULT_HEIGHT) / 2,
      zoom * curRate || dpr
    );
  };

  // 获取svg的ViewerDOM
  getSVGViewer = () => {
    const { getSvgDom } = this.props;
    if (typeof getSvgDom === "function") {
      if (this.Viewer && this.Viewer.ViewerDOM) {
        getSvgDom(this.Viewer.ViewerDOM);
      }
    }
  };

  // 双击地图，地图全屏居中
  doubleClickHandle = () => {
    if (this.viewerValue) {
      this.Viewer.setValue(this.viewerValue);
      this.viewerValue = undefined;
    } else {
      this.viewerValue = this.Viewer.getValue();
      this.Viewer.fitToViewer();
    }
  };

  // 设置地图位于中心
  setMapOnCenter = (Viewer) => {
    const { componentWidth, componentHeight } = this.props;
    Viewer.setPointOnViewerCenter(
      (Number(componentWidth) || DEFAULT_WIDTH) / 2,
      (Number(componentHeight) || DEFAULT_HEIGHT) / 2,
      dpr || ZOOM_FACTOR
    );
  };

  // 切换地图的控制模式
  changeTool = (nextTool) => {
    this.setState({ tool: nextTool });
  };

  // 清空已选的元素集合
  clearSelectElement = () => {
    this.setState({ selectedEle: [] }, () => {
      const { onSelect, onClick } = this.props;
      if (typeof onSelect === "function") {
        onSelect([]);
      }
      if (typeof onClick === "function") {
        onClick({});
      }
    });
  };

  // 删除已选的元素
  deleteSelect = (id) => {
    const { selectedEle } = this.state;
    const { deleteFinish } = this.props;
    const index = selectedEle.findIndex(
      (item) => String(item.mapElementId) === String(id)
    );
    if (index >= 0) {
      selectedEle.splice(index, 1);
    }
    this.setState({ selectedEle });
    if (typeof deleteFinish === "function") {
      deleteFinish();
    }
  };

  // 设定特定元素到屏幕中间
  setEleToCenter = (element) => {
    console.log(element, "setEleToCenter");
    const { centerEleRate } = this.props;
    if (element.stationx && element.stationy) {
      this.Viewer.setPointOnViewerCenter(
        Number(element.stationx) + Number(element.customElementWidth || 0) / 2,
        Number(element.stationy) + Number(element.customElementHeight || 0) / 2,
        centerEleRate
      );
    } else {
      window.console.warn("setEleToCenter element miss stationx & stationy.");
    }
  };

  // 选择地图上的元素
  onClickHandle = (element, visible) => {
    const {
      multiple, // 多选模式
      onClick, // 单选回调方法
      onSelect, // 多选回调方法
      onClickError, // 点击后不能选中异常回调方法
      clickableElement, // 可以点击的元素id集合，不传即都可以选择
      clickableType, // 可以点击的元素类型集合，不传即都可以选择
      clickableState, // 可以点击的元素状态集合，不传即都可以选择
      selectableType, // 可选择的元素类型，批量操作必须传
      // selectMode, // 拖拽多选模式
      mapSpaceJump, // 是否打开区域跳转开关
      reSetMapId, // 返回选中的素材对应的mapId
      showStateIds,
      clickToCenter,
    } = this.props;
    const { selectedEle } = this.state;
    // 不显示的元素不能点击，返回错误码100
    if (!visible) {
      onClickError(100, element);
      return;
    }

    // 如果是拖拽多选模式，多选后点击单选，则清空选中元素
    // if(!multiple && selectMode){
    //   this.clearSelectElement();
    //   return;
    // }

    // 判断元素的id是否可以选中，返回错误码101
    if (
      clickableElement &&
      (clickableElement.length === 0 ||
        (clickableElement.length > 0 &&
          !clickableElement.some(
            (v) => String(v) === String(element.mapElementId)
          )))
    ) {
      onClickError(101, element);
      return;
    }
    // 判断元素的类型是否可以选中（如：工位，会议室等），返回错误码102
    if (
      clickableType &&
      (clickableType.length === 0 ||
        (clickableType.length > 0 &&
          !clickableType.some((v) => v === element.svgTypeCode)))
    ) {
      onClickError(102, element);
      return;
    }
    // 判断元素的状态是否可以选中（如：空闲，占用等），返回错误码103
    if (
      clickableState &&
      (clickableState.length === 0 ||
        (clickableState.length > 0 &&
          !clickableState.some((v) => v === element.objectSvgStateCode)))
    ) {
      onClickError(103, element);
      return;
    }

    // 只能批量操作必须选择类型
    if (multiple && !selectableType) {
      onClickError(105, element);
      return;
    }

    // 只能多选同类型的元素，返回错误码104
    if (multiple && element.svgTypeCode !== selectableType && selectableType !== 'ALL') {
      if (typeof onClickError === "function") {
        onClickError(104, element);
      }
      return;
    }

    // 判断点击的素材是否是绑定区域的，是则返回mapId
    if (mapSpaceJump && element.extend) {
      let mapObj = JSON.parse(element.extend);
      let stateObj =
        showStateIds.find(
          (o) => String(o.id) === String(element.mapElementId)
        ) || {};
      if (stateObj && stateObj[0] && stateObj[0].extend) {
        mapObj = JSON.parse(stateObj[0]);
      }
      reSetMapId(mapObj);
      return;
    }

    const index = selectedEle.findIndex(
      (item) => item.mapElementId === element.mapElementId
    );
    if (index >= 0) {
      // 从列表中删除
      selectedEle.splice(index, 1);
    } else {
      // 如果不允许多选，需要先删除选择的工位
      !multiple && selectedEle.splice(0, selectedEle.length);
      // 增加一个工位
      selectedEle.push(element);
    }
    this.setState({ selectedEle });
    // 多选返回，每次返回所有选中的对象
    if (typeof onSelect === "function") {
      onSelect(selectedEle);
    }
    // 单选返回，如果是多选模式，会返回刚选中的对象
    if (typeof onClick === "function") {
      onClick(element);
      // 如果是单选并且打开点击素材剧中放大
      if (clickToCenter && selectedEle.length > 0) {
        element.customElementWidth = element?.axisx;
        element.customElementHeight = element?.axixy;
        this.setEleToCenter(element);
      }
    }
  };

  // 渲染地图上区域元素
  renderElementsArea = (element) => {
    const {
      visibleElement,
      visibleType,
      visibleState,
      noName,
      markId,
      showStateIds,
      elementsColor,
      tooltipContent,
      markSvg,
      selectedSvg,
      defaultTooltipKey,
      multiple,
      isGenders,
      markStateId,
      markStateSvg,
      hideNameType,
      textColor,
      customTextStyle,
    } = this.props;
    const { selectedEle, locationSvgMark, mapColorSet, baseMap } =
      this.state;
    let genders = ""; // 男女，外包人员前加头像
    // 2、结合素材文件，渲染地图上元素
    let svgContent = <g key={element.mapElementId} />;
    svgContent = (
      <svg
        width={element.customElementWidth || 0}
        height={element.customElementHeight || 0}
      >
        <g dangerouslySetInnerHTML={{ __html: element.customElement }} />
      </svg>
    );
    // 3、渲染元素上需要显示的文字以及计算文字的旋转角度，需要保持文字正向显示
    let contentText = element.objectName || "";
    let defaultTooltipKeyName = "";
    let tooltipObj = "";
    let contentSvg = "";
    let offset = [
      Number(element.customElementWidth) / 2 || 0,
      Number(element.customElementHeight) / 2 || 0,
    ];
    let center = [
      Number(element.customElementWidth) / 2,
      Number(element.customElementHeight) / 2,
    ];
    let groupRotate = Number(element.cycleValue) % 360;
    if (groupRotate < 0) {
      groupRotate += 360;
    }
    let rotate = 0;
    if (
      (groupRotate >= 0 && groupRotate < 90) ||
      (groupRotate >= 270 && groupRotate <= 360)
    ) {
      rotate = 0;
    } else if (groupRotate >= 90 && groupRotate < 270) {
      rotate = 180;
    }
    // 4、修改元素的透明度
    let opacity = 1;
    // 5、渲染元素的颜色，如果对应的素材不支持修改颜色，则替换对应状态的素材
    let fill = COLOR_DEFAULT;

    // 20210616 新增设置素材状态颜色和透明度，objectColor如果不为空，并且以#开头，则为设置的素材颜色；不为空并且不已#开头，根据objectColor的内容去查找素材状态颜色；否则为默认颜色
    if (element.objectColor) {
      if (element.objectColor.startsWith("#")) {
        fill = element.objectColor;
      } else if (element.objectColor === "free") {
        opacity = mapColorSet?.freeTransparent || 1;
        fill = mapColorSet?.freeRgb || "#69E5A5";
      } else if (element.objectColor === "busy") {
        opacity = mapColorSet?.busyTransparent || 1;
        fill = mapColorSet?.busyRgb || "#FD7C7C";
      } else if (element.objectColor === "disabled") {
        opacity = mapColorSet?.disabledTransparent || 1;
        fill = mapColorSet?.disabledRgb || "#D1D8DF";
      }
    }

    const customStyle = elementsColor.length > 0;
    // 如果组件没有传进样式，按默认显示，如果有传参数，按参数修改
    if (!showStateIds && !customStyle) {
      if (
        selectedEle.some((item) => item.mapElementId === element.mapElementId)
      ) {
        fill = COLOR_SELECTED;
      }
      if (element.svgStateElement) {
        svgContent = (
          <svg
            width={element.customElementWidth || 0}
            height={element.customElementHeight || 0}
          >
            <g dangerouslySetInnerHTML={{ __html: element.customElement }} />
          </svg>
        );
      }
    } else {
      // 如果组件外部传入主动变更状态的集合，则替换响应的状态元素
      let stateObj =
        showStateIds.find(
          (o) => String(o.id) === String(element.mapElementId)
        ) || {};
      // 通过elementsColor传入的颜色优先级高
      if (customStyle) {
        const tmpCustomStyle =
          elementsColor.find(
            (o) => String(o.id) === String(element.mapElementId)
          ) || {};
        stateObj = { ...stateObj, ...tmpCustomStyle };
      }

      if (stateObj) {
        if (stateObj.text) {
          contentText = stateObj.text;
        }
        // 如果设置了颜色按相应颜色显示
        if (stateObj.color) {
          if (stateObj.color.startsWith("#")) {
            fill = stateObj.color;
          } else if (stateObj.color === "free") {
            opacity = mapColorSet?.freeTransparent || 1;
            fill = mapColorSet?.freeRgb || "#69E5A5";
          } else if (stateObj.color === "busy") {
            opacity = mapColorSet?.busyTransparent || 1;
            fill = mapColorSet?.busyRgb || "#FD7C7C";
          } else if (stateObj.color === "disabled") {
            opacity = mapColorSet?.disabledTransparent || 1;
            fill = mapColorSet?.disabledRgb || "#D1D8DF";
          }
        }
        // console.log('customStyle stateObj', fill, stateObj)
        if (!_.isEmpty(stateObj.contentObj)) {
          if (isGenders && stateObj.contentObj.userName) {
            if (Number(stateObj.genders) === 1) {
              genders = "👨";
            } else if (Number(stateObj.genders) === 2) {
              genders = "👩";
            } else if (Number(stateObj.genders) === 3) {
              genders = "‍👨‍💻";
            }
          }
          tooltipObj = stateObj.contentObj;
          defaultTooltipKeyName = tooltipObj[defaultTooltipKey];
        }
      }
    }
    // 6、根据需求，判断元素在地图上是否需要显示
    let visible = true;
    // 判断元素的id是否可以显示
    if (
      visibleElement &&
      (visibleElement.length === 0 ||
        (visibleElement.length > 0 &&
          !visibleElement.some(
            (v) => String(v) === String(element.mapElementId)
          )))
    ) {
      visible = false;
    }
    // 判断元素的类型（如：工位，会议室等）
    if (
      visibleType &&
      (visibleType.length === 0 ||
        (visibleType.length > 0 &&
          !visibleType.some((v) => v === element.svgTypeCode)))
    ) {
      visible = false;
    }
    // 判断元素的状态（如：空闲，占用等）
    if (
      visibleState &&
      (visibleState.length === 0 ||
        (visibleState.length > 0 &&
          !visibleState.some((v) => v === element.objectSvgStateCode)))
    ) {
      visible = false;
    }
    // 7、添加被搜索元素的标记
    let markIcon = "",
      markOnlyId = markId;
    if (typeof markId === "object" && Array.isArray(markId)) {
      markId.forEach((m) => {
        if (String(m) === String(element.mapElementId)) {
          markOnlyId = m;
        }
      });
    }
    if (markOnlyId && String(markOnlyId) === String(element.mapElementId)) {
      const param = {
        rotate: Number(element.cycleValue) || 0,
        width: Number(element.customElementWidth) || 0,
        height: Number(element.customElementHeight) || 0,
      };

      if (locationSvgMark && locationSvgMark.element) {
        let svgWidth = "";
        let svgHeight = "";
        if (locationSvgMark.viewBox) {
          const viewSize = locationSvgMark.viewBox.split(" ") || [];
          svgWidth = (viewSize?.length === 4 && viewSize[2]) || "";
          svgHeight = (viewSize?.length === 4 && viewSize[3]) || "";
        }
        const objParam = Object.assign(
          {},
          { ...param },
          { svgWidth, svgHeight }
        );
        markIcon = (
          <MarkIcon
            {...objParam}
            svgPath={() => {
              return (
                <g
                  dangerouslySetInnerHTML={{
                    __html: locationSvgMark.element,
                  }}
                />
              );
            }}
          />
        );
      }
      if (markSvg) {
        markIcon = <MarkIcon {...param} svgPath={markSvg} />;
      }

      if (!locationSvgMark && !markSvg) {
        markIcon = <MarkIcon {...param} />;
      }
    }

    // 8、添加被选中元素的标记
    let selectedIcon = "",
      selectedId = "",
      selectedKey = "";
    selectedEle.forEach((s, index) => {
      if (s.mapElementId === element.mapElementId) {
        selectedId = s.mapElementId;
        selectedKey = (Number(index) + 1).toString();
      }
    });
    if (selectedId && String(selectedId) === String(element.mapElementId)) {
      const param = {
        rotate: Number(element.cycleValue) || 0,
        width: Number(element.customElementWidth) || 0,
        height: Number(element.customElementHeight) || 0,
        text: selectedKey,
        multiple,
      };
      selectedIcon = <SelectedIcon {...param} svgPath={selectedSvg} />;
    }

    // 9、添加根据状态标记元素的标记
    let markStateIcon = "";
    if (markStateId && markStateId.length > 0) {
      markStateId.forEach((m) => {
        if (String(m) === String(element.mapElementId)) {
          const param = {
            rotate: Number(element.cycleValue) || 0,
            width: Number(element.customElementWidth) || 0,
            height: Number(element.customElementHeight) || 0,
          };
          markStateIcon = <MarkIcon {...param} svgPath={markStateSvg} />;
        }
      });
    }

    // console.log('renderElements',  element.svgTypeCode, visible)
    // 渲染
    let textRole = 0;
    if (element.cycleValue) {
      textRole = 0 - Number(element.cycleValue);
    }

    // hideNameType 是否有不显示内容的素材类型
    let hideName = false;
    if (hideNameType?.length > 0) {
      if (hideNameType.indexOf(element.svgTypeCode) !== -1) {
        hideName = true;
      }
    }

    const { fontColor } = baseMap;
    let textShowColor = fontColor || '#fff';
    if (textColor) {
      textShowColor = textColor;
    }

    return visible ? (
      <g
        key={element.mapElementId}
        strokeWidth="1"
        fill={fill}
        fillOpacity={visible ? opacity : 0}
        transform={`
          translate(${element.stationx || 0}, ${element.stationy || 0}) 
          scale(1, 1) 
          rotate(
              ${element.cycleValue || 0},
              ${(Number(element.customElementWidth) || 0) / 2},
              ${(Number(element.customElementHeight) || 0) / 2}
          )
        `}
        onMouseEnter={() => {
          // 鼠标移动到元素上，显示气泡框
          if (typeof tooltipContent === "function") {
            contentSvg = tooltipContent(tooltipObj);
          }
          this.setState({
            tipObj: {
              contentSvg: contentSvg,
              name: defaultTooltipKeyName,
              width: Number(element.customElementWidth) || 0,
              height: Number(element.customElementHeight) || 0,
              x: Number(element.stationx) || 0,
              y: Number(element.stationy) || 0,
            },
            showTip: visible,
          });
        }}
        onMouseLeave={() => {
          // 鼠标从元素上移开，关闭气泡框
          this.setState({ showTip: false });
        }}
        onTouchStart={(e) => {
          // 触屏端触发
          e.stopPropagation();
          // 判断默认行为是否可以被禁用
          if (e.cancelable) {
            // 判断默认行为是否已经被禁用
            if (!e.defaultPrevented) {
              e.preventDefault();
            }
          }
          if (typeof tooltipContent === "function") {
            contentSvg = tooltipContent(tooltipObj);
          }
          this.setState(
            {
              tipObj: {
                contentSvg: contentSvg,
                name: defaultTooltipKeyName,
                width: Number(element.customElementWidth) || 0,
                height: Number(element.customElementHeight) || 0,
                x: Number(element.stationx) || 0,
                y: Number(element.stationy) || 0,
              },
              showTip: visible,
            },
            () => this.setState({ showTip: false })
          );
        }}
        onClick={() => {
          this.onClickHandle(element, visible);
        }}
      >
        {svgContent}
        {!noName && !hideName && contentText && (
          <SvgTextEllipsis
            transform={`rotate(${textRole}, ${center[0]}, ${center[1]})`}
            dx={offset[0]}
            dy={offset[1]}
            fill={textShowColor}
            fontFamily="ArialMT"
            textAnchor="middle"
            fontSize={customTextStyle?.fontSize || 12}
            width={Number(element.customElementHeight) || 0}
          >
            {genders + contentText}
          </SvgTextEllipsis>
        )}
        {markStateIcon}
        {markIcon}
        {selectedIcon}
      </g>
    ) : (
      ""
    );
  };

  // touch 空白处隐藏 tooltip
  onTouchStart = (e) => {
    // 支持 touch 事件，用地图空白处 TouchStart 取消 tooltip
    if (HAVE_TOUCH_EVENT) {
      e.stopPropagation();
      // 判断默认行为是否可以被禁用
      if (e.cancelable) {
        // 判断默认行为是否已经被禁用
        if (!e.defaultPrevented) {
          e.preventDefault();
        }
      }
      this.setState({ showTip: false });
    }
  };

  // 渲染地图上元素集合
  renderElements = (element) => {
    const {
      visibleElement,
      visibleType,
      visibleState,
      noName,
      markId,
      showStateIds,
      elementsColor,
      tooltipContent,
      markSvg,
      selectedSvg,
      multiple,
      defaultTooltipKey,
      textColor,
      isGenders,
      markStateId,
      markStateSvg,
      isTouchDevice,
      hideNameType,
      elementRenderHandle,
      textNum,
      textState
    } = this.props;
    const { allElements, selectedEle, locationSvgMark, mapColorSet, baseMap } =
      this.state;
    // 1、找到地图上元素对应的素材
    const eleSvg =
      allElements &&
      allElements.find((e) => String(e.svgId) === String(element.svgId));
    // 2、结合素材文件，渲染地图上元素
    let svgContent = <g key={element.mapElementId} />;
    let genders = ""; // 男女，外包人员前加头像
    if (!eleSvg) {
      if (Number(element.svgId) === 0) {
        return this.renderElementsArea(element);
      }
      return svgContent;
    }
    if (eleSvg.viewBox) {
      svgContent = (
        <svg
          viewBox={eleSvg.viewBox}
          width={eleSvg.svgWidth || 0}
          height={eleSvg.svgHeight || 0}
        >
          <g dangerouslySetInnerHTML={{ __html: eleSvg.svgElement }} />
        </svg>
      );
    } else {
      svgContent = (
        <g dangerouslySetInnerHTML={{ __html: eleSvg.svgElement }} />
      );
    }
    // 3、渲染元素上需要显示的文字以及计算文字的旋转角度，需要保持文字正向显示
    let contentText = element.objectName || "";
    let defaultTooltipKeyName = "";
    let tooltipObj = "";
    let contentSvg = "";
    let offset = [Number(eleSvg.axisx) || 0, Number(eleSvg.axixy) || 0];
    let center = [Number(eleSvg.svgWidth) / 2, Number(eleSvg.svgHeight) / 2];

    let groupRotate = Number(element.cycleValue) % 360;
    if (groupRotate < 0) {
      groupRotate += 360;
    }
    let rotate = 0;
    if (
      (groupRotate >= 0 && groupRotate < 90) ||
      (groupRotate >= 270 && groupRotate <= 360)
    ) {
      rotate = 0;
    } else if (groupRotate >= 90 && groupRotate < 270) {
      rotate = 180;
    }

    // 4、修改元素的透明度
    let opacity = 1;
    // 5、渲染元素的颜色，如果对应的素材不支持修改颜色，则替换对应状态的素材
    let fill = COLOR_DEFAULT;

    // 20210616 新增设置素材状态颜色和透明度，objectColor如果不为空，并且以#开头，则为设置的素材颜色；不为空并且不已#开头，根据objectColor的内容去查找素材状态颜色；否则为默认颜色
    if (element.objectColor) {
      if (element.objectColor.startsWith("#")) {
        fill = element.objectColor;
      } else if (element.objectColor === "free") {
        opacity = mapColorSet?.freeTransparent || 1;
        fill = mapColorSet?.freeRgb || "#69E5A5";
      } else if (element.objectColor === "busy") {
        opacity = mapColorSet?.busyTransparent || 1;
        fill = mapColorSet?.busyRgb || "#FD7C7C";
      } else if (element.objectColor === "disabled") {
        opacity = mapColorSet?.disabledTransparent || 1;
        fill = mapColorSet?.disabledRgb || "#D1D8DF";
      }
    }

    //  window.console.log(fill, element, mapColorSet);

    const customStyle = elementsColor.length > 0;
    // 如果组件没有传进样式，按默认显示，如果有传参数，按参数修改
    if (!showStateIds && !customStyle) {
      if (
        selectedEle.some((item) => item.mapElementId === element.mapElementId)
      ) {
        fill = COLOR_SELECTED;
      }
      if (element.svgStateElement) {
        if (eleSvg.viewBox) {
          svgContent = (
            <svg
              viewBox={eleSvg.viewBox}
              width={eleSvg.svgWidth || 0}
              height={eleSvg.svgHeight || 0}
            >
              <g
                dangerouslySetInnerHTML={{ __html: element.svgStateElement }}
              />
            </svg>
          );
        } else {
          svgContent = (
            <g dangerouslySetInnerHTML={{ __html: element.svgStateElement }} />
          );
        }
      }
    } else {
      // 如果组件外部传入主动变更状态的集合，则替换响应的状态元素
      let stateObj =
        showStateIds.find(
          (o) => String(o.id) === String(element.mapElementId)
        ) || {};
      // 通过elementsColor传入的颜色优先级高
      if (customStyle) {
        const tmpCustomStyle =
          elementsColor.find(
            (o) => String(o.id) === String(element.mapElementId)
          ) || {};
        stateObj = { ...stateObj, ...tmpCustomStyle };
      }

      if (stateObj) {
        if (stateObj.text) {
          contentText = stateObj.text;
        }
        // 如果设置了颜色按相应颜色显示
        if (stateObj.color) {
          if (stateObj.color.startsWith("#")) {
            fill = stateObj.color;
          } else if (stateObj.color === "free") {
            opacity = mapColorSet?.freeTransparent || 1;
            fill = mapColorSet?.freeRgb || "#69E5A5";
          } else if (stateObj.color === "busy") {
            opacity = mapColorSet?.busyTransparent || 1;
            fill = mapColorSet?.busyRgb || "#FD7C7C";
          } else if (stateObj.color === "disabled") {
            opacity = mapColorSet?.disabledTransparent || 1;
            fill = mapColorSet?.disabledRgb || "#D1D8DF";
          }
        }
        // console.log('customStyle stateObj', fill, stateObj)
        if (!_.isEmpty(stateObj.contentObj)) {
          if (isGenders && stateObj.contentObj.userName) {
            if (Number(stateObj.genders) === 1) {
              genders = "👨";
            } else if (Number(stateObj.genders) === 2) {
              genders = "👩";
            } else if (Number(stateObj.genders) === 3) {
              genders = "‍👨‍💻";
            }
          }
          tooltipObj = stateObj.contentObj;
          defaultTooltipKeyName = tooltipObj[defaultTooltipKey];
        }
        if (eleSvg.svgStateList && eleSvg.svgStateList.length > 0) {
          // 如果有状态根据状态显示相应素材
          const eleState = eleSvg.svgStateList.find((d) => {
            return d.svgStateCode === stateObj.state;
          });
          if (eleState) {
            fill = null;
            if (eleSvg.viewBox) {
              svgContent = (
                <svg
                  viewBox={eleSvg.viewBox}
                  width={eleSvg.svgWidth || 0}
                  height={eleSvg.svgHeight || 0}
                >
                  <g
                    dangerouslySetInnerHTML={{
                      __html: eleState.svgStateElement,
                    }}
                  />
                </svg>
              );
            } else {
              svgContent = (
                <g
                  dangerouslySetInnerHTML={{ __html: eleState.svgStateElement }}
                />
              );
            }
          }
        }
      }
    }
    // 6、根据需求，判断元素在地图上是否需要显示
    let visible = true;
    // 判断元素的id是否可以显示
    if (
      visibleElement &&
      (visibleElement.length === 0 ||
        (visibleElement.length > 0 &&
          !visibleElement.some(
            (v) => String(v) === String(element.mapElementId)
          )))
    ) {
      visible = false;
    }
    // 判断元素的类型（如：工位，会议室等）
    if (
      visibleType &&
      (visibleType.length === 0 ||
        (visibleType.length > 0 &&
          !visibleType.some((v) => v === element.svgTypeCode)))
    ) {
      visible = false;
    }
    // 判断元素的状态（如：空闲，占用等）
    if (
      visibleState &&
      (visibleState.length === 0 ||
        (visibleState.length > 0 &&
          !visibleState.some((v) => v === element.objectSvgStateCode)))
    ) {
      visible = false;
    }
    // 7、添加被搜索元素的标记
    let markIcon = "",
      markOnlyId = markId;
    if (typeof markId === "object" && Array.isArray(markId)) {
      markId.forEach((m) => {
        if (String(m) === String(element.mapElementId)) {
          markOnlyId = m;
        }
      });
    }
    if (markOnlyId && String(markOnlyId) === String(element.mapElementId)) {
      const param = {
        rotate: Number(element.cycleValue) || 0,
        width: Number(eleSvg.svgWidth) || 0,
        height: Number(eleSvg.svgHeight) || 0,
        mapElementId: element.mapElementId || null,
        eleSvg,
        element
      };

      if (locationSvgMark && locationSvgMark.element) {
        let svgWidth = "";
        let svgHeight = "";
        if (locationSvgMark.viewBox) {
          const viewSize = locationSvgMark.viewBox.split(" ") || [];
          svgWidth = (viewSize?.length === 4 && viewSize[2]) || "";
          svgHeight = (viewSize?.length === 4 && viewSize[3]) || "";
        }
        const objParam = Object.assign(
          {},
          { ...param },
          { svgWidth, svgHeight }
        );
        markIcon = (
          <MarkIcon
            {...objParam}
            svgPath={() => {
              return (
                <g
                  dangerouslySetInnerHTML={{
                    __html: locationSvgMark.element,
                  }}
                />
              );
            }}
          />
        );
      }
      if (markSvg) {
        markIcon = <MarkIcon {...param} svgPath={markSvg} />;
      }

      if (!locationSvgMark && !markSvg) {
        markIcon = <MarkIcon {...param} />;
      }
    }

    // 8、添加被选中元素的标记
    let selectedIcon = "",
      selectedId = "",
      selectedKey = "";
    selectedEle.forEach((s, index) => {
      if (s.mapElementId === element.mapElementId) {
        selectedKey = (Number(index) + 1).toString();
        selectedId = s.mapElementId;
      }
    });
    if (selectedId && String(selectedId) === String(element.mapElementId)) {
      const param = {
        rotate: Number(element.cycleValue) || 0,
        width: Number(eleSvg.svgWidth) || 0,
        height: Number(eleSvg.svgHeight) || 0,
        text: selectedKey || "",
        multiple,
      };

      selectedIcon = <SelectedIcon {...param} svgPath={selectedSvg} />;
    }
    // console.log('renderElements',  element.svgTypeCode, visible)
    // 渲染
    let textRole = 0;
    if (eleSvg.direction !== -1 && element.cycleValue) {
      textRole = Number(eleSvg.direction) - Number(element.cycleValue);
    }

    // 360项目定制
    let textColorShow = textColor;
    let fillOpacity = 1;
    let fontSize = eleSvg.fontSize || 12;
    //
    // 会议素材文字颜色和字体大小
    if (element && element.svgTypeCode === 'meeting-room') {
      textColorShow = '#595959';
      fontSize = 20;
    }

    if (element && textState && textState.split(',').includes(element.svgTypeCode)) {
      textColorShow = '#595959';
      fontSize = 20;
    }

    // 工位编号只显示后四位
    const isNum = contentText && !Number.isNaN(
      Number.parseInt(contentText.slice(contentText.length - textNum), 10),
    )
    if (element && element.svgTypeCode === 'workspace' && isNum) {
      contentText = contentText.slice(-textNum);
    }

    try {

      // 当素材文字方向为默认，且素材旋转180度时，文字再旋转180度
      if (eleSvg.direction === -1 && element.cycleValue === 180) {

        const spanDom = document.createElement('span');
        spanDom.style.fontSize = `${eleSvg.fontSize || 12}px`;
        spanDom.style.opacity = '0';
        spanDom.style.fontFamily = 'ArialMT';
        spanDom.style.textAnchor = "middle";
        spanDom.innerHTML = contentText;
        document.body.append(spanDom);
        const sizeD = {};
        sizeD.height = spanDom.offsetHeight;
        sizeD.width = spanDom.offsetWidth;
        spanDom.remove();

        textRole = 180;
        center[0] = Number(eleSvg.axisx);
        center[1] = Number(eleSvg.axixy);
        offset[1] += sizeD.height / 2;
      }

    } catch (e) {
      console.error("浏览器内核过低，不支持 document.body.append 方法，请升级。")
    }

    // 选中的素材颜色为蓝色  待确认
    // if (selectedId && String(selectedId) === String(element.mapElementId)) {
    //   fill = '#1B84FF';
    // }
    //

    // 9、添加根据状态标记元素的标记
    let markStateIcon = "";
    if (markStateId && markStateId.length > 0) {
      markStateId.forEach((m) => {
        if (String(m) === String(element.mapElementId)) {
          const param = {
            rotate: Number(element.cycleValue) || 0,
            width: Number(eleSvg.svgWidth) || 0,
            height: Number(eleSvg.svgHeight) || 0,
          };
          markStateIcon = <MarkIcon {...param} svgPath={markStateSvg} />;
        }
      });
    }

    // 文字颜色
    const { fontColor } = baseMap;
    let textShowColor = fontColor || '#fff';
    if (eleSvg.fontColor) {
      textShowColor = eleSvg.fontColor;
    }
    if (textColor) {
      textShowColor = textColor;
    }

    // hideNameType 是否有不显示内容的素材类型
    let hideName = false;
    if (hideNameType?.length > 0) {
      if (hideNameType.indexOf(element.svgTypeCode) !== -1) {
        hideName = true;
      }
    }
    const {windowsTouchSupport, mobile} = this.props;

    return visible ? (
      <g
        key={element.mapElementId}
        strokeWidth="1"
        fill={fill}
        fillOpacity={visible ? opacity : 0}
        transform={`
          translate(${element.stationx || 0}, ${element.stationy || 0}) 
          scale(1, 1) 
          rotate(
              ${element.cycleValue || 0},
              ${(Number(eleSvg.svgWidth) || 0) / 2},
              ${(Number(eleSvg.svgHeight) || 0) / 2}
          )
        `}
        onMouseEnter={(e) => {
          // 鼠标移动到元素上，显示气泡框
          // console.log('鼠标进入 事件触发')
          if (!HAVE_TOUCH_EVENT) {
            // 不支持 touch 事件，用 mouseEnter 触发 tooltip
            if (typeof tooltipContent === "function") {
              contentSvg = tooltipContent(tooltipObj);
            }
            this.setState({
              tipObj: {
                contentSvg: contentSvg,
                name: defaultTooltipKeyName,
                width: Number(eleSvg.svgWidth) || 0,
                height: Number(eleSvg.svgHeight) || 0,
                x: Number(element.stationx) || 0,
                y: Number(element.stationy) || 0,
              },
              showTip: visible,
            });
          }
        }}
        onMouseLeave={() => {
          // 鼠标从元素上移开，关闭气泡框
          // console.log('鼠标离开 事件触发')
          // 不支持 touch 事件，用 mouseLeave 取消 tooltip
          if (!HAVE_TOUCH_EVENT) {
            this.setState({ showTip: false });
          }
        }}
        onTouchEnd={(e) => {
          if (isTouchDevice) {
            e.preventDefault();
            e.stopPropagation();
            this.onClickHandle(element, visible);
          }
        }}
        onTouchStart={(e) => {
          // 触屏端触发
          // console.log('Touch 事件触发')
          // 支持 touch 事件，用 TouchStart 触发 tooltip
          if (windowsTouchSupport || HAVE_TOUCH_EVENT) {
            e.stopPropagation();
            // 判断默认行为是否可以被禁用
            if (e.cancelable) {
              // 判断默认行为是否已经被禁用
              if (!e.defaultPrevented) {
                e.preventDefault();
              }
            }
            if (typeof tooltipContent === "function") {
              contentSvg = tooltipContent(tooltipObj);
            }
            this.setState({
              tipObj: {
                contentSvg: contentSvg,
                name: defaultTooltipKeyName,
                width: Number(eleSvg.svgWidth) || 0,
                height: Number(eleSvg.svgHeight) || 0,
                x: Number(element.stationx) || 0,
                y: Number(element.stationy) || 0,
              },
              showTip: visible,
            });
          }
        }}
        onClick={() => {
          this.onClickHandle(element, visible);
        }}
      >
        {elementRenderHandle ? elementRenderHandle(svgContent, element) : svgContent}
        {!noName && !hideName && contentText && (
          <SvgTextEllipsis
            transform={`rotate(${textRole}, ${center[0]}, ${center[1]})`}
            dx={offset[0]}
            dy={offset[1]}
            fill={textShowColor}
            fontFamily="ArialMT"
            textAnchor="middle"
            fontSize={eleSvg.fontSize || 12}
            width={Number(eleSvg.svgWidth) || 0}
          >
            {genders + contentText}
          </SvgTextEllipsis>
        )}
        {markStateIcon}
        {markIcon}
        {selectedIcon}
      </g>
    ) : (
      ""
    );
  };

  // 设置选择区域中心点
  setSelectedCenter = ({ x, y }) => {
    this.setState({ selectedCenter: { x, y } });
  };

  // 设置选择区域大小
  setSelectedArea = ({ dragX, dragY }) => {
    const { selectedCenter } = this.state;
    const { x, y } = selectedCenter;
    let centerX = x;
    let centerY = y;
    const dragWidth = Math.abs(x - dragX);
    const dragHeight = Math.abs(y - dragY);
    if (dragX < x && dragY < y) {
      centerX = dragX;
      centerY = dragY;
    } else if (dragX > x && dragY < y) {
      centerY = dragY;
    } else if (dragX < x && dragY > y) {
      centerX = dragX;
    }
    this.setState({
      selectedArea: { x: centerX, y: centerY, dragWidth, dragHeight },
    });
  };

  // 排序
  compare = (prop1, prop2) => {
    return function sort(a, b) {
      const value1 = a[prop1];
      const value2 = b[prop1];

      if (value1 === value2) {
        return a[prop2] - b[prop2];
      }
      return value1 - value2;
    };
  };

  // 获取选择区域内的元素
  setSelectElements = () => {
    const {
      onSelect, // 多选回调方法
      selectableType,
      clickableElement,
    } = this.props;

    if (!selectableType) {
      return;
    }

    const { selectedArea, mapElements } = this.state;
    const { x, y, dragWidth, dragHeight } = selectedArea;
    //  window.console.log(selectedArea);
    const selectList = [];
    const clickFlag = (ele) =>
      !clickableElement || clickableElement?.includes(ele.mapElementId);
    mapElements.forEach((ele) => {
      if (
        (ele.svgTypeCode === selectableType || selectableType === 'ALL') &&
        ele.centerx >= x &&
        ele.centerx <= x + dragWidth &&
        ele.centery >= y &&
        ele.centery <= y + dragHeight &&
        clickFlag(ele) && (dragWidth > 0 || dragHeight > 0)
      ) {
        selectList.push(ele);
      }
    });
    // console.log(selectList);

    selectList.sort(this.compare("stationy", "stationx"));

    this.setState({ selectedEle: selectList });
    onSelect(selectList);

    this.setState({
      selectedArea: { x: 0, y: 0, dragWidth: 0, dragHeight: 0 },
    });
  };

  render() {
    // console.log('maprender')
    // 分别是组件宽度，组件高度，组件背景色，地图缩放，地图移动, ,导引线开始图标，导引线结束图标，导引线引线样式
    const {
      mapId,
      componentWidth,
      componentHeight,
      background,
      SVGBackground,
      style,
      SVGStyle,
      mapZoom,
      mapMove,
      touchable,
      pathStartSvg,
      pathEndSvg,
      pathStyle,
      selectMode,
      setSelectMode,
      selectableType,
      scaleFactorMin,
      scaleFactorMax,
      legendList,
      legendRender,
      showPath,
      markId,
      isTouchDevice,
      AppendSvg,
      mapExtraProps,
      pathLineKey,
      mapKey
    } = this.props;

    // 分别是移动控制，viewer值，缩放，地图对象，地图上元素集合，显示气泡，气泡内容，导引线起点，导引线终点，导引线路径
    const {
      tool,
      svgValue,
      zoom,
      baseMap,
      mapElements,
      showTip,
      tipObj,
      selectedCenter,
      selectedArea,
      mapColorSet,
    } = this.state;
    // 分别是地图的svg素材，地图的url，地图的宽度，地图的高度，地图的面积
    const { baseMapElement, width, height, areaAge } = baseMap;
    const baseMapUrl = baseMap[mapKey.url]

    // 额外需要增加的高度和宽度，目前用于留白边
    const extraWidth = mapExtraProps?.width || 0;
    const extraHeight = mapExtraProps?.height || 0;

    // 地图图片需要显示的宽度和高度
    const mapWidth = Number(width || componentWidth) + extraWidth;
    const mapHeight = Number(height || componentHeight) + extraHeight;

    // 控制地图缩放
    const svgZoom = mapZoom === undefined || mapZoom;
    // 控制地图移动
    const svgMove = mapMove === undefined || mapMove;
    // 控制可触摸
    const touchZoom = touchable === undefined || touchable;
    // 控制可拖拽
    const svgSelectMode = selectMode === undefined || selectMode;

    let start = null;
    let end = null;
    let path = "";

    
    if (showPath && mapElements && markId) {
      mapElements.forEach((element) => {
        if (String(element.mapElementId) === String(markId)) {
          if (element[pathLineKey.mid]) {
            path = element[pathLineKey.mid];
            start = {
              x: element[pathLineKey.start].split(",")[0],
              y: element[pathLineKey.start].split(",")[1],
            };
            end = {
              x: element[pathLineKey.end].split(",")[0],
              y: element[pathLineKey.end].split(",")[1],
            };
          } else {
            // console.log('else element.lineMid')
            path = "";
            start = null;
            end = null;
          }
        }
        return;
      });
    } else if (path) {
      // 清空导引线
      path = "";
      start = null;
      end = null;
    }

    let showPathStyle = {
      stroke: mapColorSet?.guidesRgb || "#00ba00",
      strokeWidth: mapColorSet?.guidesWidth
        ? `${mapColorSet?.guidesWidth}px`
        : "5px",
      opacity: mapColorSet?.guidesTransparent || "1",
    };
    if (Object.keys(pathStyle).length > 0) {
      // showPathStyle = { ...pathStyle }
      //stroke: '#00ba00', strokeWidth: '5px', opacity: '1'
      showPathStyle = {
        stroke: pathStyle.stroke || "#00ba00",
        strokeWidth: pathStyle.strokeWidth || "5px",
        opacity: pathStyle.opacity || "1",
      };
    }

    return (
      <div>
        {!touchZoom && (
          <div
            style={{
              position: "absolute",
              zIndex: 1,
              width: componentWidth || DEFAULT_WIDTH,
              height: componentHeight || DEFAULT_HEIGHT,
            }}
          />
        )}
        <ReactSVGPanZoom
          key={mapId}
          width={componentWidth || DEFAULT_WIDTH}
          height={componentHeight || DEFAULT_HEIGHT}
          background={background || DEFAULT_BACKGROUND}
          SVGBackground={SVGBackground || DEFAULT_SVGBACKGROUND}
          detectAutoPan={false} //
          detectWheel={svgZoom} // 是否滚轮控制缩放
          detectPinchGesture={svgZoom} // 手指手势是否控制缩放
          tool={svgMove ? tool : TOOL_NONE} // none pan zoom-in, zoom-out, auto
          onChangeTool={this.changeTool}
          scaleFactor={ZOOM_FACTOR}
          toolbarProps={{
            position: POSITION_NONE,
          }}
          miniatureProps={{
            position: POSITION_NONE,
          }}
          ref={(Viewer) => {
            this.Viewer = Viewer;
          }}
          value={svgValue}
          onChangeValue={(value) =>
            this.setState({ zoom: value.a, svgValue: value })
          }
          disableDoubleClickZoomWithToolAuto
          // onDoubleClick={() => svgZoom && svgMove && this.doubleClickHandle()}
          onTouchStart={(e) => {
            this.onTouchStart(e);
          }}
          onTouchEnd={(e) => {
            if (isTouchDevice && HAVE_TOUCH_EVENT) {
              e.stopPropagation();
              // 判断默认行为是否可以被禁用
              if (e.cancelable) {
                // 判断默认行为是否已经被禁用
                if (!e.defaultPrevented) {
                  e.preventDefault();
                }
              }
              if (selectMode && selectableType) {
                this.setSelectElements();
                setSelectMode(false);
                this.setSelectedCenter({ x: null, y: null });
              }
            }
          }}
          SVGStyle={SVGStyle}
          style={style}
          onMouseDown={(e) => {
            e.originalEvent.stopPropagation();
            e.originalEvent.preventDefault();

            if (selectMode && selectableType) {
              this.setSelectedCenter({ x: e.x, y: e.y });
            }
          }}
          onMouseUp={(e) => {
            e.originalEvent.stopPropagation();
            e.originalEvent.preventDefault();

            if (selectMode && selectableType) {
              this.setSelectElements();
              setSelectMode(false);
              this.setSelectedCenter({ x: null, y: null });
            }
          }}
          onMouseMove={(e) => {
            e.originalEvent.stopPropagation();
            e.originalEvent.preventDefault();

            if (
              selectMode &&
              selectableType &&
              _.isNumber(selectedCenter.x) &&
              _.isNumber(selectedCenter.y)
            ) {
              this.setSelectedArea({ dragX: e.x, dragY: e.y });
            }
          }}
          scaleFactorMax={scaleFactorMax}
          scaleFactorMin={scaleFactorMin}
        >
          <svg width={mapWidth} height={mapHeight}>
            {AppendSvg && <AppendSvg width={mapWidth} height={mapHeight} />}
            {!baseMapElement && baseMapUrl && (
              <image
                xlinkHref={baseMapUrl}
                width={mapWidth}
                height={mapHeight}
              />
            )}
            {baseMapElement && (
              <g
                dangerouslySetInnerHTML={{ __html: baseMapElement }}
                width={mapWidth}
                height={mapHeight}
              />
            )}
            <g transform={`translate(${extraWidth / 2}, ${extraHeight / 2})`}>
              {mapElements &&
                mapElements.map((ele) => this.renderElements(ele))}
            </g>
            <path
              d={path}
              style={Object.assign({}, PATH_STYLE, showPathStyle)}
              radius="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {/* 导引线图标缩放，跟随整体放大缩小，不需要用自己缩放 */}
            {start && path && (
              <StartPosition {...start} zoom={1} svgPath={pathStartSvg} />
            )}
            {end && path && (
              <EndPosition {...end} zoom={1} svgPath={pathEndSvg} />
            )}
            {areaAge && (
              <g transform="translate(1, 1)" width="140" height="40">
                <rect dx="0" dy="0" width="140" height="40" fill="#eeeeee" />
                <text
                  fill="#000000"
                  width="140"
                  height="40"
                  dx="70"
                  dy="20"
                  fontSize="14"
                  textAnchor="middle"
                  dominantBaseline="middle"
                >
                  {`地图面积为: ${areaAge}m²`}
                </text>
              </g>
            )}
            {selectMode && selectableType && (
              <g cursor="crosshair">
                <rect width={mapWidth} height={mapHeight} fillOpacity="0" />
                <rect
                  width={selectedArea.dragWidth}
                  height={selectedArea.dragHeight}
                  transform={`translate(${selectedArea.x},${selectedArea.y})`}
                  fill="#e1f1fc"
                  fillOpacity="0.5"
                  stroke="#8bc9f3"
                  strokeWidth="1"
                  strokeDasharray="1,1"
                />
              </g>
            )}
            {/* 导出PDF时增加图例 */}
            {mapId &&
              legendRender &&
              legendRender(legendList, mapHeight, mapWidth)}
            {/* 气泡不缩放，不会跟随整体放大缩小 */}
            <ToolTip showTip={showTip} tipObj={tipObj} zoom={zoom} />
          </svg>
        </ReactSVGPanZoom>
      </div>
    );
  }
}

WaferMap.propTypes = {
  mapId: PropsTypes.string.isRequired, // 地图id
  componentWidth: PropsTypes.number, // 组件宽度
  componentHeight: PropsTypes.number, // 组件高度
  background: PropsTypes.string, // 组件背景颜色
  SVGBackground: PropsTypes.string, // svg背景颜色
  SVGStyle: PropsTypes.object, // svg背景颜色
  style: PropsTypes.string, // svg背景颜色
  visibleElement: PropsTypes.array, // 可显示的元素id集合
  visibleType: PropsTypes.array, // 可显示的元素类型集合
  visibleState: PropsTypes.array, // 可显示的元素状态集合
  clickableElement: PropsTypes.array, // 可点击的元素id集合
  clickableType: PropsTypes.array, // 可点击的元素类型集合
  clickableState: PropsTypes.array, // 可点击的元素状态集合
  onClick: PropsTypes.func, // 单选回调方法
  onSelect: PropsTypes.func, // 多选回调方法
  onClickError: PropsTypes.func, // 不可点击事件回调
  mapZoom: PropsTypes.bool, // 控制地图缩放
  mapMove: PropsTypes.bool, // 控制地图移动
  multiple: PropsTypes.bool, // 多选状态
  noName: PropsTypes.bool, // 不显示元素上名称
  showPath: PropsTypes.bool, // 是否显示导引线
  markId: PropsTypes.oneOfType([
    PropsTypes.string,
    PropsTypes.arrayOf(PropsTypes.string),
  ]), // 被查询或标记的元素id
  showStateIds: PropsTypes.array, // 显示不同元素的不同状态，数据结构：[{id: 1, state: 'XX', color: '#fff', text: ''}, {}]
  reloadMap: PropsTypes.bool, // 重新加载地图
  reloadFinish: PropsTypes.func, // 重新加载地图完成回调
  touchable: PropsTypes.bool, // 可触摸控制
  deleteId: PropsTypes.string, // 删除已选的元素id
  selectedIds: PropsTypes.array, // 选中元素 ID 集合
  deleteFinish: PropsTypes.func, // 删除已选元素后的回调
  tooltipContent: PropsTypes.func, //鼠标悬浮在素材上的小气泡内容和样式
  elementsColor: PropsTypes.array, // 按照元素id设置颜色,数据结构：[{id: 1, color: '#fff'}, {}]
  pathStartSvg: PropsTypes.func, // 导引线起点 svg 图标函数
  pathEndSvg: PropsTypes.func, //导引线 终点 svg 图标函数
  pathStyle: PropsTypes.object, // 导引线样式
  markSvg: PropsTypes.func, // 搜索定位标记 svg 图标函数
  selectedSvg: PropsTypes.func, // 选中标记 svg 图标函数
  defaultTooltipKey: PropsTypes.string, // 气泡里面 可以自定义默认显示取的key
  getSvgDom: PropsTypes.func, // 获取svg的ViewerDOM
  signatureKey: PropsTypes.string, // 签名key
  restfulSignature: PropsTypes.bool, // 控制是否签名
  selectMode: PropsTypes.bool, // 控制是否可拖拽
  setSelectMode: PropsTypes.func, // 重置拖拽多选状态
  selectableType: PropsTypes.string, // 批量操作类型
  selectedEle: PropsTypes.array, // 选中的元素集合回显用
  setSelectedEleFinish: PropsTypes.func, // 回显选中的元素集合后的回显，此时需要程序控制置空选中元素集合
  textColor: PropsTypes.string, // 元素上文字颜色
  fitWidthOrHeight: PropsTypes.string, // 按高度还是宽度适配
  scaleFactorMax: PropsTypes.number, // 地图最大缩放倍数
  scaleFactorMin: PropsTypes.number, // 地图最小缩放倍数
  mapSpaceJump: PropsTypes.bool, // 是否打开区域跳转开关
  reSetMapId: PropsTypes.string, // 绑定区域的素材对应区域的mapId
  requestPrefix: PropsTypes.string, // 请求 URL 前缀
  legendList: PropsTypes.array, //导出PDF时增加图例
  legendRender: PropsTypes.func, //图例渲染函数
  isGenders: PropsTypes.bool, // 是否在素材人名前显示男 女 外包类型头像
  onElementsLoad: PropsTypes.func, // 素材获取完成回调
  zoomRate: PropsTypes.number, // 地图适配放大倍数
  defaultPath: PropsTypes.string, // 默认路径前缀
  markStateId: PropsTypes.array, // 标记元素状态id
  markStateSvg: PropsTypes.func, //  标记元素状态 svg 图标函数
  isTouchDevice: PropsTypes.bool, // 是否是一体机设备
  centerEleRate: PropsTypes.number, // 设置中心素材放大倍数
  centerElement: PropsTypes.object, // 设置中心素材
  clickToCenter: PropsTypes.bool, // 点击素材剧中放大
  hideNameType: PropsTypes.array, // 隐藏显示内容的素材类型
  AppendSvg: PropsTypes.object, // 追加显示的svg，主要用于显示地图区域
  mapExtraProps: PropsTypes.object, // 额外需要处理的属性，目前可以在地图的宽高上追加宽高
  pathLineKey: PropsTypes.object, // 导引线显示的字段
  mapKey: PropsTypes.object, // 地图显示的字段
  windowsTouchSupport: PropsTypes.bool, // 是否是 windows 触摸屏
  elementRenderHandle: PropsTypes.func, // 元素渲染时自定义处理
  mobile: PropsTypes.bool, // 判断是否手机移动端
  textNum: PropsTypes.number, //截取工位编号的长度
  textState: PropsTypes.string, // 素材文字状态
  customTextStyle: {} // 360定制自定义素材文字大小
};

WaferMap.defaultProps = {
  componentWidth: DEFAULT_WIDTH,
  componentHeight: DEFAULT_HEIGHT,
  background: DEFAULT_BACKGROUND,
  SVGBackground: DEFAULT_SVGBACKGROUND,
  visibleElement: undefined,
  visibleType: undefined,
  visibleState: undefined,
  clickableElement: undefined,
  clickableType: undefined,
  clickableState: undefined,
  onClick: () => {},
  onSelect: () => {},
  onClickError: () => {},
  mapZoom: true,
  mapMove: true,
  multiple: false,
  noName: false,
  showPath: false,
  markId: "",
  showStateIds: [],
  elementsColor: [],
  reloadMap: false,
  reloadFinish: () => {},
  touchable: true,
  deleteId: "",
  selectedIds: [],
  deleteFinish: () => {},
  tooltipContent: () => {},
  pathStartSvg: undefined,
  pathEndSvg: undefined,
  pathStyle: {},
  markSvg: undefined,
  selectedSvg: undefined,
  defaultTooltipKey: "",
  getSvgDom: () => {},
  signatureKey: null,
  restfulSignature: false,
  style: {}, // svg背景颜色
  SVGStyle: {}, // svg背景颜色
  selectMode: false, //是否可拖拽
  setSelectMode: () => {},
  selectableType: "", //批量操作类型
  selectedEle: [],
  setSelectedEleFinish: () => {},
  textColor: "", // 元素上文字颜色
  fitWidthOrHeight: "",
  scaleFactorMax: undefined,
  scaleFactorMin: undefined,
  mapSpaceJump: false,
  reSetMapId: () => {},
  requestPrefix: "",
  legendList: [], //图例数据格式[{color:   , text:   }]
  legendRender: undefined, //图例渲染函数
  isGenders: false, // 是否在素材人名前显示男 女 外包类型头像
  onElementsLoad: () => {},
  zoomRate: 1, // 地图适配放大倍数
  defaultPath: "vsk/", // 默认路径前缀
  markStateId: [],
  markStateSvg: undefined,
  isTouchDevice: false,
  centerEleRate: 1, // 设置中心素材放大倍数
  centerElement: {}, // 设置中心素材
  clickToCenter: false, // 点击素材剧中放大
  hideNameType: [],
  pathLineKey: { start: 'lineStart', end: 'lineEnd', mid: 'lineMid'  },
  mapKey: { url: 'baseMapUrl'  },
  windowsTouchSupport: false, // 是否是 windows 触摸屏
  elementRenderHandle: undefined, // 元素渲染时自定义处理
  mobile: false, // 默认不是移动手机端
  textNum: 4, //截取工位编号的长度
  textState: '', // 素材文字状态
  customTextStyle: {} // 360定制自定义素材文字大小
};

export default WaferMap;
